import { useTranslation } from "react-i18next";
import DoorEmpty from "./DoorEmpty";
import LinkButton from "./LinkButton";

const SUPPORT_URL = "/coaching-portal/support/contact";
// TODO: MSB University article on FaciliKey (address not defined yet).
const LEARN_URL = "#";

const NotConnected = () => {
  const { t } = useTranslation("coaching-portal");
  return (
    <div className="door-card">
      <DoorEmpty
        big
        tone="info"
        title={t("doorAccess.notConnected.title")}
        text={t("doorAccess.notConnected.text")}
        actions={
          <>
            <LinkButton href={SUPPORT_URL} sz="large">
              {t("doorAccess.notConnected.contact")}
            </LinkButton>
            <LinkButton
              type="secondary"
              sz="large"
              href={LEARN_URL}
              target="_blank"
              rel="noreferrer"
            >
              {t("doorAccess.notConnected.learn")}
            </LinkButton>
          </>
        }
      >
        <div className="door-explainer">
          <div>
            <span>{t("doorAccess.notConnected.logsTitle")}</span>
            <p>{t("doorAccess.notConnected.logsText")}</p>
          </div>
          <div>
            <span>{t("doorAccess.notConnected.busyTitle")}</span>
            <p>{t("doorAccess.notConnected.busyText")}</p>
          </div>
        </div>
      </DoorEmpty>
    </div>
  );
};

export default NotConnected;
